import { UbivuCalendarViewModule } from './../../../ubivu-calendar-view/src/lib/ubivu-calendar-view.module';
import { CommonModule } from '@angular/common';
import { CommonTopBar } from './Helper/common-top-bar';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { LightHelper } from './Helper/light.helper';
import { NgModule } from '@angular/core';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { SharedModule } from 'libs/shared/src/lib/shared.module';
import { SubpanelDropdownComponent } from './subpanel-dropdown/subpanel-dropdown.component';
import { TopBarActionEventsComponent } from './top-bar-action-events/top-bar-action-events.component';
import { TopBarComponent } from './top-bar.component';
import { TopBarFilterComponent } from './top-bar-filter/top-bar-filter.component';
import { TopBarNodeStatusComponent } from './top-bar-node-status/top-bar-node-status.component';
import { TopBarTagComponent } from './top-bar-tag/top-bar-tag.component';
import { UbiMapModule } from 'libs/ubi-map/src/lib/ubi-map.module';
import { TopBarRefreshRateComponent } from './top-bar-refresh-rate/top-bar-refresh-rate.component';
import { IconsModule } from 'libs/icons/src/lib/icons.module';
import { SavedFilterComponent } from './saved-filter/saved-filter.component';
import { SAVED_FILTER_COMPONENT } from './top-bar-dialog.tokens';

@NgModule({ declarations: [TopBarComponent, TopBarTagComponent, TopBarNodeStatusComponent, TopBarActionEventsComponent, TopBarFilterComponent, SubpanelDropdownComponent, TopBarRefreshRateComponent, SavedFilterComponent],
    exports: [TopBarComponent], imports: [CommonModule, SharedModule, FormsModule, ScrollingModule, UbiMapModule, IconsModule, UbivuCalendarViewModule], providers: [LightHelper, CommonTopBar, { provide: SAVED_FILTER_COMPONENT, useValue: SavedFilterComponent }, provideHttpClient(withInterceptorsFromDi())] })
export class TopBarModule {}
